import { datadogRum } from '@datadog/browser-rum';

import { TransferAppDependencies } from '@wetransfer/ad-sdk';

import Helper from '@wetransfer/transfer/helper';
import { userHasPaidTier } from '@wetransfer/transfer/helper/user';
import Analytics from '@wetransfer/transfer/modules/analytics';
import {
  hasFullConsent,
  hasRejectedAll,
  hasPartialConsent,
} from '@wetransfer/transfer/modules/consent-manager/tc-model';
import { getFullVariant } from '@wetransfer/transfer/modules/experiments';
import Router from '@wetransfer/transfer/modules/router';

export const dependencies: TransferAppDependencies = {
  Datadog: datadogRum,
  Analytics,
  Experiments: {
    getFullVariant,
  },
  TcModel: {
    hasFullConsent,
    hasRejectedAll,
    hasPartialConsent,
  },
  Router,
  helpers: {
    getWTPlus: Helper.getWTPlus,
    user: {
      userHasPaidTier,
    },
  },
};
